import config from '@/config'
const BASE_URL = config.API_BASE_URL

const Client = {
  createUrl (url) {
    return BASE_URL + url
  },

  createQueryString (params) {
    return Object.keys(params).map(key => key + '=' + encodeURIComponent(params[key])).join('&');
  },
  checkStatus (response) {
    if (response.ok) {
      return response
    } else {
      return Promise.reject(response)
    }
  },

  getOptions( method ) {
    let options = {
      method: method,
      mode: 'cors',
      redirect: 'follow',
      headers: {
        'Content-Type': 'application/json',
        'accept':'application/json'
      }
    }
    return options
  },

  request(url, options) {
    return fetch(url, options)
      .then( Client.checkStatus )
      .then( r => r.json() )
  },

  get (url, data) {
    const queryString = this.createQueryString(data)
    url = url + '?' + queryString
    const options = this.getOptions('GET')
    return this.request(url, options)
  },

  post (url, data) {
    let options = this.getOptions('POST')
    options.body = JSON.stringify(data)
    return this.request(url, options)
  }
}

export default Client